export const PERSISTENT_ALERT_BANNER_CONTAINER_ID = 'persistent-alert-banner-container'
export const PERSISTENT_ALERT_BANNER_INSERT_AFTER_CLASS = 'topbar-container'
export const JUSIA_ALERT_CLICKED_LINK = 'jusia_alert_clicked_link'
export const STUDENTS_BENEFIT_ALERT_DISMISSED = 'students_benefit_alert_dismissed'
